<div class="js-tooltip">
  <button
    class="js-tooltip-btn"
    id="tooltip_{{ id }}"
    [innerHTML]="iconImage"
    [aswTooltip]="tooltipContent"
    [tooltipTop]="tooltipTop"
    [tooltipDisplayType]="tooltipDisplayType"
    [displayAreaClass]="displayAreaClass"
  ></button>
</div>
